




















































import { Component, Vue, Watch } from 'vue-property-decorator'
import Moment from 'moment'
import { Factories } from '@finx/web-repository'
import ApiLegacy from '@finx/web-repository/src/apis/Legacy/Legacy'
import { Loading } from '@/types/_'
import StoreRelatorios from '@/store/Relatorios'

@Component({
  props: {
    dataSelecionada: {
      type: String,
    },
    filter: {
      type: String,
    },
    detail: {
      type: String,
    },
    detailValue: {
      type: String,
    },
    refreshRelatorio: {
      type: Boolean,
    },
  },
})

export default class ComponentViewRelatorioRecebimentoFontePagadora extends Vue {
  fontesPagadoras = []
  relatorioPaciente = []
  relatorioMes = []
  relatorioDate = {
    start: null,
    end: null,
  }

  loading: Loading = {
    status: false,
    text: 'Carregando...',
  }

  data() {
    return {
      toggleDivergencias: true,

      recebimentoFilters: [
        {
          id: 1,
          slug: 'fonte-pagadora',
          name: 'Fonte pagadora',
        },
        {
          id: 2,
          slug: 'mes',
          name: 'Mês',
        },
      ],
    }
  }

  get prestador(): any {
    return StoreRelatorios.getters.PRESTADOR
  }

  mounted() {
    this.getRelatorioDate()
    this.getRelatorioByMonth()
    // this.getBothRelatorios()
  }

  getBothRelatorios() {
    // @ts-ignore
    if (this.filter === 'fonte-pagadora') {
      this.getRelatorios()
    }

    // @ts-ignore
    if (this.filter === 'mes') {
      this.getRelatorioLastSixMonths()
    }
  }

  @Watch('refreshRelatorio')
  watchRefreshRelatorio() {
    this.getRelatorioDate()

    this.getBothRelatorios()
  }

  @Watch('dataSelecionada')
  // @ts-ignore
  onPropertyChanged(value: string) {
    this.getRelatorioDate()

    this.getBothRelatorios()
  }

  @Watch('detailValue')
  // @ts-ignore
  opropertyChanged(value: string) {
  }

  // @ts-ignore
  @Watch('filter')
  propertyChanged(value: string) {
    // @ts-ignore
    this.$router.push(`/relatorio/recebimento/${this.filter}`)
    if (value === 'mes') this.$ga.event('recebimento', 'divergencia-mes', this.$user.profile.email)
  }

  async getRelatorioDate() {
    // @ts-ignore
    this.relatorioDate.start = Moment().subtract(6, 'months').startOf('month').format('YYYY-MM-DD')
    // @ts-ignore
    this.relatorioDate.end = Moment().endOf('month').format('YYYY-MM-DD')
  }

  async getRelatorios() {
    this.loading.status = true
    let prestadorId = null

    const hasPrestador = Object.keys(this.prestador).length > 0
    if (hasPrestador) prestadorId = this.prestador.id

    const request = await ApiLegacy
      .Reports
      .getRecebimentoFontePagadora(this.relatorioDate.start,
        this.relatorioDate.end, null, prestadorId)

    const success = Factories.Apis.success(request)

    if (success) {
      this.fontesPagadoras = request.data.data
    }
    this.loading.status = false
  }

  async getRelatorioByMonth() {
    // @ts-ignore
    const mounthSelected = Moment(this.detailValue).format('YYYY-MM')
  }

  async getRelatorioLastSixMonths() {
    this.loading.status = true
    let prestadorId = null

    const hasPrestador = Object.keys(this.prestador).length > 0
    if (hasPrestador) prestadorId = this.prestador.id

    const dateStart = Moment(new Date()).subtract(6, 'months').startOf('month').format('YYYY-MM-DD')
    const dateEnd = Moment(new Date()).add(6, 'months').endOf('month').format('YYYY-MM-DD')

    const relatorioMes = await ApiLegacy.Reports.getRecebimento(dateStart, dateEnd, prestadorId)
    this.relatorioMes = relatorioMes.data.data
    this.loading.status = false
  }
}
